const TERMINAL_ITEM_STATUSES = new Set(["Completed", "Cancelled", "Declined"]);

function normalizedTeeth(value) {
  return Array.isArray(value) ? value : [];
}

export function dentureScopeRequirement(item) {
  if (!item || TERMINAL_ITEM_STATUSES.has(item.status)) return null;

  const kind = String(item.multi_tooth_kind || "").toLowerCase();
  const hasArch = ["upper", "lower"].includes(String(item.arch || "").toLowerCase());
  const hasReplacementTeeth = normalizedTeeth(item.teeth).length > 0;

  if (kind === "partial_denture" && (!hasArch || !hasReplacementTeeth)) {
    return {
      code: "partial_denture_scope_missing",
      itemId: item.item_id,
      procedureId: item.procedure_id,
      procedureName: item.procedure_name || "Partial denture",
      actionLabel: "Add arch & teeth",
      message: "Choose the arch and every tooth this partial denture replaces.",
    };
  }

  if (kind === "full_denture" && !hasArch) {
    return {
      code: "full_denture_arch_missing",
      itemId: item.item_id,
      procedureId: item.procedure_id,
      procedureName: item.procedure_name || "Complete denture",
      actionLabel: "Add arch",
      message: "Choose the arch for this complete denture.",
    };
  }

  return null;
}

export function buildChairsideHandoffRequirements(bundle) {
  return (Array.isArray(bundle?.procedures) ? bundle.procedures : [])
    .map(dentureScopeRequirement)
    .filter(Boolean);
}
